module.exports = __webpack_public_path__ + "static/media/MacizoLogo.a17ad59f.png";